import ContainerLayout from '@/components/Layout/ContainerLayout'
import HeaderLayout from '@/components/Layout/HeaderLayout'
import { Paper } from '@/components/Paper'
import { useRef, useState } from 'react'
import Header from '../components/Header'
import TabelaTipoCombustivel from './Components/TabelaLocalidade'
import TabelaLocalidade from './Components/TabelaLocalidade'


const mockPermissions = [
  { id: 1, localidade: 'São Paulo', ativo: true },
  { id: 2, localidade: 'Rio de Janeiro', ativo: true },
  { id: 3, localidade: 'Belo Horizonte', ativo: true },
  { id: 4, localidade: 'Porto Alegre', ativo: false },
  { id: 5, localidade: 'Salvador', ativo: true },
  { id: 6, localidade: 'Curitiba', ativo: false },
  { id: 7, localidade: 'Fortaleza', ativo: true },
  { id: 8, localidade: 'Recife', ativo: true },
  { id: 9, localidade: 'Manaus', ativo: false },
  { id: 17, localidade: 'Brasília', ativo: true },
];



function Localidade() {
    const [isFilterVisible, setIsFilterVisible] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    const headers = [
      { label: 'Selecionar', key: 'checkbox',isVisible: true },
      { label: 'ID', key: 'id', isVisible: true },
      { label: 'Localidade', key: 'localidade', isVisible: true },
      { label: 'Ativo', key: 'ativo', isVisible: true },
    ];

    const [visibleHeaders, setVisibleHeaders] = useState(headers);

    const handleDelete = (selectedData: any[]) => {
    };

    const printRef = useRef(null); 
  return (
    <>
      <ContainerLayout>
        <HeaderLayout title="Portaria" calendarInput />
        <Paper m={6} bg="white" py={4} px={2} rounded="xl" shadow="sm" border="1px solid rgba(200, 200, 200, .4)">
          <Header
            onHeadersChange={setVisibleHeaders}
            isFilterVisible={isFilterVisible}
            headers={headers}
            isMenuEnabled
            onToggleFilter={() => setIsFilterVisible((prev) => !prev)}
            onView={() => console.log("Visualizar ação executada")}
            printRef={printRef} 
            title={'Localidade'}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            
          />
        
        
          <div id="print-content" ref={printRef}>
              <TabelaLocalidade headers={visibleHeaders}  onDelete={handleDelete} dados={mockPermissions} valoPesquisa={searchTerm}  />
          </div>
        </Paper>
      </ContainerLayout>
    </>
  )
}

export default Localidade